import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import { Trans } from "react-i18next";
import ModalToBody from "../../../base/ModalToBody";
import { ajaxErrorHandler, defaultSuccess } from "../../../libs/utils";
import { createTransportRequest } from "../../../services/api/transportRequests";
import TransportRequestForm from "../../forms/TransportRequestForm";

class CreateGatekeepingRequestButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };

    this._closeModal = this._closeModal.bind(this);
    this._openModal = this._openModal.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
  }

  static propTypes = {
    registration: PropTypes.object,
    event: PropTypes.object,
    reloadRequests: PropTypes.func,
    admin: PropTypes.bool,
    refreshRequests: PropTypes.func,
    locations: PropTypes.array
  };

  _closeModal() {
    this.setState({ showModal: false });
  }

  _openModal() {
    this.setState({ showModal: true });
  }

  _handleSubmit(values) {
    const self = this;
    let registrationId = undefined;
    if (this.props.admin) {
      registrationId = values.registrationId;
    } else {
      registrationId = this.props.registration.id;
    }

    return new Promise(function(resolve, reject) {
      let promises = [];

      let data = {
        crewMemberId: values.crewMemberId,
        locationId: values.locationId,
        driverName: values.driverName,
        driverTelephone: values.driverTelephone,
        truckType: values.truckType,
        licensePlate: values.licensePlate,
        transportAt: ""
      };

      for (let i = 1; i <= values.times; i++) {
        if (values.deletedTimes.indexOf(i) === -1) {
          let time = values["date_" + i]?.format("YYYY-MM-DD");

          if (values["all_day_" + i]) {
            time += " 00:00:00 +0200";
          } else {
            time += " " + values["time_" + i] + " +0200";
          }
           
          const dataToSend = {
            ...data,
            allDay: values["all_day_" + i] ?? false,
            transportAt: moment(time, "YYYY-MM-DD HH:mm Z")
              .utcOffset(0)
              .format("YYYY-MM-DD HH:mm:ss")
          };

          promises.push(createTransportRequest(registrationId, dataToSend));
        }
      }

      Promise.all(promises)
        .then(data => {
          self.props.refreshRequests();
          defaultSuccess("Transport Requested");
          self._closeModal();
        })
        .catch(ajaxErrorHandler)
        .then(resolve);
    });
  }

  render() {
    const { showModal } = this.state;
    const { registration, event, locations, admin } = this.props;

    if (showModal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }

    return (
      <div>
        <button
          type="button"
          className="m-portlet__nav-link btn btn-primary m-btn m-btn--icon"
          onClick={this._openModal}
        >
          <span>
            <i className="la la-plus" />
            <span>
              <Trans>RegistrationGatekeepingRequestAddButton</Trans>
            </span>
          </span>
        </button>

        <ModalToBody>
          <div
            className="modal fade show"
            id="m_modal_4"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            style={{
              display: showModal ? "block" : "none",
              zIndex: "1039"
            }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Request Transport
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this._closeModal}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                {showModal && (
                  <TransportRequestForm
                    registration={registration}
                    event={event}
                    locations={locations}
                    onSubmit={this._handleSubmit}
                    admin={!!admin}
                  />
                )}
              </div>
            </div>
          </div>

          <div
            className={"modal-backdrop fade " + (showModal ? " show" : "")}
            style={{
              display: showModal ? "block" : "none",
              zIndex: "1038"
            }}
          />
        </ModalToBody>
      </div>
    );
  }
}

export default CreateGatekeepingRequestButton;
